module.exports = __webpack_public_path__ + "static/assets/c3001fd85ca1ac8d93574b0be649c5ca.svg";